/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Byoa_Local_SetupInputs */

const en_byoa_local_setup = /** @type {(inputs: Byoa_Local_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set up an agent on my computer`)
};

const id_byoa_local_setup = /** @type {(inputs: Byoa_Local_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siapkan agent di komputerku`)
};

/**
* | output |
* | --- |
* | "Set up an agent on my computer" |
*
* @param {Byoa_Local_SetupInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const byoa_local_setup = /** @type {((inputs?: Byoa_Local_SetupInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Byoa_Local_SetupInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_byoa_local_setup(inputs)
	return en_byoa_local_setup(inputs)
});